export const titleInfoSkele = {
	width: 149,
	height: 85
}

export const mediaInfoSkele = {
	width: 226.5,
	height: 130
}

export const filteredSkele = {width: 220, height: 122}

export const carouselSkele = {width: 185, height: 105}